import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DashboardQueries } from '../../../../cp/shared/enums/DashboardQueries';
import { widgetFilters } from '../../../shared/enums/widgetFilters';
import { WidgetSearch } from '@app/cp/shared/models/WidgetSearch';

@Component({
    selector: 'cp-tech-hours-summary',
    templateUrl: './tech-hours-summary.component.html',
    styleUrls: ['./tech-hours-summary.component.scss'],
    standalone: false
})
export class TechHoursSummaryComponent implements OnInit {

    constructor() { }

    @Input() chartType: string = 'line';
    @Input() inputSearchParams: WidgetSearch;
    @Output() loaderState = new EventEmitter<any>();
    @Output() loaderErrorState = new EventEmitter<any>();
    @Output() searchParams = new EventEmitter<WidgetSearch>(true);

    widgetQuery: DashboardQueries = DashboardQueries.techHoursSummary;
    chartSearchFilters: widgetFilters[] = [widgetFilters.customer,
    widgetFilters.locations,
    widgetFilters.dateRange,
    widgetFilters.technicians,
        widgetFilters.status,
        widgetFilters.onCallRegion, 
    widgetFilters.divisions];

    ngOnInit() {
    }

    changeLoader(e) {
        this.loaderState.emit(e);
    }

    changeErrorLoader(e) {
        this.loaderErrorState.emit(e);
    }

    setSearchParams(searchParams: WidgetSearch) {
        this.searchParams.emit(searchParams);
    }

}
